import { IconAngleRight, mapper } from '@maia/icons';
import { ActionButtonLink, TableCell } from '@maia/ui';
import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { Claims } from './queryOptions';

type Claim = Claims['response'][number];

const columns: ColumnDef<Claim>[] = [
  {
    accessorKey: 'reference',
    header: 'Referentie',
    cell: ({ row }) => (
      <TableCell.Link
        to="/claims/$guid"
        params={{
          guid: row.original.guid,
        }}
      >
        {row.original.reference}
      </TableCell.Link>
    ),
  },
  {
    accessorKey: 'occurredAt',
    header: 'Schade datum',
    cell: ({ row }) => <TableCell.Date date={row.original.occurredAt} />,
  },
  {
    accessorKey: 'insurance',
    header: 'Product',
    enableSorting: false,
    cell: ({ row }) => (
      <TableCell.Product
        title={row.original.insurance.title}
        icon={mapper(row.original.insurance.icon)}
      />
    ),
  },
  {
    accessorKey: 'cause',
    header: 'Kenmerk',
    enableSorting: false,
    cell: ({ row }) => <TableCell.Text text={row.original.cause} />,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    enableSorting: false,
    cell: ({ row }) => <TableCell.Tag {...row.original.status} />,
  },
  {
    id: 'actions',
    cell: ({ row }) => (
      <div className="flex gap-x-12 items-center">
        <ActionButtonLink
          icon={IconAngleRight}
          size="small"
          to="/claims/$guid"
          params={{
            guid: row.original.guid,
          }}
        />
      </div>
    ),
  },
];

export function useClaimsTable(data?: Claims) {
  return useReactTable({
    columns,
    data: data?.response ?? [],
    rowCount: data?.response.length,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
  });
}
